import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "./ui/dialog";
import { Button } from "./ui/button";

export function Field({ label, children, className = "", required }) {
  return (
    <div className={className}>
      {label && <label className="block text-xs font-semibold text-slate-600 mb-1.5">{label}{required && <span className="text-red-500 ml-0.5">*</span>}</label>}
      {children}
    </div>
  );
}

const inputCls = "w-full px-3 py-2 rounded-lg border border-slate-200 bg-white text-sm text-navy-800 outline-none focus:border-gold focus:ring-1 focus:ring-gold/30 transition-colors placeholder:text-slate-400";

export function Input(props) {
  return <input {...props} className={`${inputCls} ${props.className || ""}`} />;
}

export function Textarea(props) {
  return <textarea {...props} className={`${inputCls} resize-y min-h-[80px] ${props.className || ""}`} />;
}

export function Select({ options, value, onChange, placeholder, testid, ...rest }) {
  return (
    <select value={value ?? ""} onChange={(e) => onChange(e.target.value)} data-testid={testid} className={inputCls} {...rest}>
      {placeholder && <option value="">{placeholder}</option>}
      {options.map((o) => {
        const val = typeof o === "string" ? o : o.value;
        const lab = typeof o === "string" ? o.replace(/_/g, " ") : o.label;
        return <option key={val} value={val}>{lab}</option>;
      })}
    </select>
  );
}

export function FormModal({ open, onClose, title, onSubmit, children, submitLabel = "Save", loading, size = "max-w-lg", testid, footerLeft }) {
  return (
    <Dialog open={open} onOpenChange={(v) => !v && onClose()}>
      <DialogContent className={`${size} max-h-[90vh] overflow-y-auto bg-white`} data-testid={testid}>
        <DialogHeader><DialogTitle className="font-display text-xl text-navy-800">{title}</DialogTitle></DialogHeader>
        <form onSubmit={(e) => { e.preventDefault(); onSubmit(); }} className="space-y-4">
          {children}
          <DialogFooter className="gap-2 pt-2 sm:justify-between">
            <div>{footerLeft}</div>
            <div className="flex gap-2">
            <Button type="button" variant="outline" onClick={onClose} data-testid="modal-cancel-btn">Cancel</Button>
            <Button type="submit" disabled={loading} className="bg-navy-800 hover:bg-navy-700 text-white" data-testid="modal-submit-btn">
              {loading ? "Saving…" : submitLabel}
            </Button>
            </div>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
}
